module.exports = __webpack_public_path__ + "img/red_shield_generator_small.0c3f00ba.png";